function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 648,
  x2: 648,
  y2: 130
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00b39f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#01ad9b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#039b91"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#077d81"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#0c546a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#131f4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#141446"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m1296 0h-1296v110.17c384.53 46.32 897.23 12.25 1296-110.17z",
  fill: "url(#a)"
});

var SvgHeaderForm = function SvgHeaderForm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 130,
    viewBox: "0 0 1296 130",
    preserveAspectRatio: "none",
    width: 1296,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderForm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/header-form.a3934862.svg";
export { ForwardRef as ReactComponent };